import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../core'
import * as healthCheck from '../health-check'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    constraints: {
      max: { value: 1 },
      min: { value: 0 },
    },
    context: core.dms.models.Attribute.Id.Context.from(
      healthCheck.RESOURCE.payload,
    ),
    description:
      'Amount a record of an entity should be weighted when calculating an overall score for the level above.',
    isOptional: true,
    name: 'Weight',
    partialId: PartialId.Standard.create('weight'),
    type: core.common.value.types.Intrinsic.Decimal,
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
